import React from 'react'

function Loader() {
  return (
    <div>
      <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
    </div>
  )
}

export default Loader
